/** Teks penemuan laporan semakan (BM). Placeholder sama dengan findings-en.ts. */
export default {
  FORMAT_UNSUPPORTED:
    'Fail ini bukan lukisan yang disokong. Simpan sebagai DWG daripada AutoCAD 2000 hingga 2018, atau sebagai DXF.',
  READ_FAILED: 'Lukisan tidak dapat dibaca.',
  LAYER_MISSING: 'Lapisan wajib {{layer}} tiada atau tidak mengandungi apa-apa yang boleh digunakan oleh semakan.',
  SITE_BOUNDARY_COUNT: 'Lapisan {{layer}} mesti mengandungi tepat satu sempadan tapak; ia mengandungi {{count}}.',
  CHECK_SKIPPED:
    'Sempadan tapak tidak dapat digunakan, jadi semakan yang bergantung padanya tidak dijalankan: penutupan, unit, lokasi, plot, label dan luas yang diisytiharkan.',
  BOUNDARY_NOT_CLOSED: 'Sempadan tapak pada {{layer}} mempunyai jurang {{gap_m}} m (toleransi {{tolerance_m}} m).',
  BLOCK_REFERENCE_PRESENT: 'Lapisan {{layer}} mengandungi {{count}} rujukan blok, yang tidak dibenarkan.',
  LAYER_HIDDEN: 'Lapisan wajib {{layer}} tersembunyi ({{state}}); ia tetap dibaca.',
  UNITS_SUSPECT: 'Tapak berukuran {{span_m}} m, di luar julat {{min_m}} hingga {{max_m}} m. Semak unit lukisan.',
  OUTSIDE_JURISDICTION:
    'Apabila dibaca dalam EPSG:{{srid}}, tapak berada di luar bidang kuasa. Semak sistem koordinat.',
  JURISDICTION_NOT_CONFIGURED: 'Tiada sempadan bidang kuasa dikonfigurasikan, jadi lokasi tapak tidak disemak.',
  DATUM_AMBIGUOUS:
    'EPSG:{{srid}} mudah dikelirukan dengan datum berhampiran yang hanya beberapa meter berbeza. Sahkan sistem koordinat.',
  GEOMETRY_REPAIRED: '{{count}} geometri telah dibaiki secara automatik.',
  GEOMETRY_INVALID: '{{count}} geometri tidak sah dan tidak dapat dibaiki.',
  OUTSIDE_SITE_IGNORED: '{{count}} fitur di luar tapak diabaikan (blok tajuk, petunjuk, inset).',
  BACKGROUND_FILL_DROPPED: '{{count}} isian latar yang meliputi tapak telah dibuang.',
  PLOT_EXCEEDS_SITE: '{{count}} plot melepasi sempadan tapak (lebihan terbesar {{max_overhang_m2}} m²).',
  LANDUSE_NO_PLOTS: 'Lapisan wajib {{layer}} tidak menghasilkan sebarang plot tertutup di dalam tapak.',
  LANDUSE_OPEN_LINES:
    'Lapisan {{layer}} mempunyai {{count}} garisan terbuka di dalam tapak. Setiap plot mesti dilukis sebagai polyline tertutup atau hatch.',
  OVERLAP_RATE: 'Plot bertindih seluas {{overlap_m2}} m² ({{pct}}% daripada tapak).',
  SLIVER_GAPS: '{{count}} jurang kecil antara plot ({{area_m2}} m² keseluruhannya).',
  UNASSIGNED_AREA: '{{area_m2}} m² tapak tidak diliputi mana-mana plot; ia diberikan kepada {{class}}.',
  LABEL_UNMATCHED: '{{count}} plot tiada label yang sepadan dengan senarai kod guna tanah.',
  AREA_MISMATCH: 'Tapak berukuran {{site_m2}} m² tetapi {{declared_m2}} m² diisytiharkan (berbeza {{diff_pct}}%).',
  UNKNOWN_LAYERS: '{{count}} lapisan bukan sebahagian daripada piawaian pelan: {{layers}}.',
  Z_FLATTENED: 'Ketinggian telah dibuang; pelan dibaca dalam 2D.',
} as const
